import { render, staticRenderFns } from "./FamiliesData.vue?vue&type=template&id=7b1911da&scoped=true"
import script from "./FamiliesData.vue?vue&type=script&lang=js"
export * from "./FamiliesData.vue?vue&type=script&lang=js"
import style0 from "./FamiliesData.vue?vue&type=style&index=0&id=7b1911da&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b1911da",
  null
  
)

export default component.exports